import React, { Component } from 'react';
import styles from './index.css';
import logo from './logo.jpg';
import SimpleLineIcon from 'react-simple-line-icons';
import {Link} from 'react-router-dom';


export default class EquipMenu extends Component {
  render() {
      return (
        <div className={styles.topMenu}>
          <div className={styles.menuLogo}>
            <Link to="/" className={styles.burger}><SimpleLineIcon name="menu" style={{fontSize:"1.125rem"}} /></Link>
            <img src={logo} alt="logo" />
          </div>

          {/*<div className={styles.accountHelp}>*/}
            {/*<div className={styles.helpTrigger}>HELP</div>*/}
            {/*<div className={styles.accountAva} />*/}

            {/*<div className={styles.accountDetails}><SimpleLineIcon name="options-vertical"  style={{fontSize:"1.125rem"}}/></div>*/}
          {/*</div>*/}
        </div>
      );
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/EquipComponents/EquipMenu/index.js